export const EXCLUDED_PARTNER_PROGRAMS = ['OUT-CollegeSuccess']
